import { createGroup as createGroupUC } from '../application/create-group'
import { deleteMessage as deleteMessageUC } from '../application/delete-message'
import { addMember, removeMember } from '../application/manage-members'
import { publishMessage } from '../application/publish-message'
import { startP2P as startP2PUC } from '../application/start-p2p'
import type { Message } from '../domain/chat'
import { chat as chatPort, notify } from '../wiring'

// Lifecycle actions for the chat UI. Each routes through a use-case (port +
// notify); the UI gets plain functions and decides what to refetch afterwards.
const useChatActions = () => {
	return {
		send: (topicId: string, text: string, replyTo?: Message) =>
			publishMessage(chatPort, topicId, text, notify, replyTo),
		startP2P: (peerId: string) => startP2PUC(chatPort, peerId, notify),
		createGroup: (name: string, memberIds: string[]) => createGroupUC(chatPort, name, memberIds, notify),
		addMember: (topicId: string, userId: string) => addMember(chatPort, topicId, userId, notify),
		removeMember: (topicId: string, userId: string) => removeMember(chatPort, topicId, userId, notify),
		deleteMessage: (messageId: string, scope: 'all' | 'self') =>
			deleteMessageUC(chatPort, messageId, scope, notify),
	}
}

export { useChatActions }
